import { Loader2Icon } from "lucide-react";
import { Button } from "@/components/ui/button";
import React from "react";

interface LoadingButtonProps extends React.ComponentProps<typeof Button> {
  loading?: boolean;
  children: React.ReactNode;
  loadingText?: React.ReactNode;
}

export function LoadingButton({
  loading = false,
  children,
  loadingText = "Please wait",
  ...props
}: LoadingButtonProps) {
  return (
    <Button
      disabled={loading || props.disabled}
      aria-busy={loading}
      aria-disabled={loading || props.disabled}
      {...props}
    >
      {loading && <Loader2Icon className="animate-spin mr-2" aria-hidden />}
      {loading ? loadingText : children}
    </Button>
  );
}
